<template>
  <div class="terms-page">
    <div class="container">
      <router-link to="/" class="back-home">← Back to Home</router-link>
      <h1>Terms &amp; Conditions</h1>

      <p class="intro">
        By downloading or using Playlist Transfer: Music Shift, these terms will automatically apply to you,
        so please read them carefully before using the app.
      </p>

      <p>
        You're not allowed to copy or modify the app, any part of the app, or our trademarks in any way.
        You're also not allowed to attempt to extract the source code of the app, translate it into other
        languages, or create derivative versions. The app itself, and all related trademarks, copyright,
        database rights, and other intellectual property rights, still belong to the Company.
      </p>

      <p>
        The Company is committed to ensuring that the app is as useful and efficient as possible. For that
        reason, we reserve the right to make changes to the app or to charge for its services, at any time
        and for any reason. We will never charge you for the app or its services without making it very clear
        to you exactly what you're paying for.
      </p>

      <p>
        Playlist Transfer: Music Shift stores and processes personal data that you have provided to us in
        order to provide our Service. It is your responsibility to keep your phone and your access to the app
        secure. We therefore recommend that you do not jailbreak or root your phone, which is the process of
        removing software restrictions and limitations imposed by the official operating system of your device.
        It could make your phone vulnerable to malware, compromise its security features, and cause the app
        to stop working properly.
      </p>

      <h2>Third-Party Services</h2>
      <p>The app uses third-party services that declare their own Terms and Conditions.</p>
      <ul>
        <li>Google Play Services</li>
        <li>AdMob</li>
        <li>Google Analytics for Firebase</li>
        <li>Firebase Crashlytics</li>
      </ul>

      <h2>Network and Device Responsibility</h2>
      <p>
        Certain functions of the app require an active internet connection. The connection can be Wi-Fi or
        provided by your mobile network provider, but the Company cannot take responsibility for the app not
        working at full functionality if you do not have internet access or if you have no remaining data
        allowance.
      </p>

      <p>
        If you're using the app outside of an area with Wi-Fi, the terms of your agreement with your mobile
        network provider will still apply. As a result, you may be charged by your mobile provider for the
        cost of data during the connection while accessing the app, including roaming data charges if you use
        the app outside of your home territory without turning off data roaming.
      </p>

      <p>
        You are also responsible for making sure your device remains charged. If it runs out of battery and
        you cannot turn it on to access the Service, the Company cannot accept responsibility.
      </p>

      <h2>Service Availability and Updates</h2>
      <p>
        While we strive to ensure that the app is updated and correct at all times, we do rely on third
        parties to provide information to us so that we can make it available to you. The Company accepts no
        liability for any loss, direct or indirect, you experience as a result of relying wholly on this
        functionality of the app.
      </p>

      <p>
        At some point, we may wish to update the app. The app is currently available on Android and iOS. The
        requirements for those systems may change, and you'll need to download updates if you want to keep
        using the app. The Company does not promise that it will always update the app so that it is relevant
        to you or compatible with the Android and iOS versions installed on your device.
      </p>

      <p>
        We may also stop providing the app and may terminate its use at any time without giving notice of
        termination to you. Unless we tell you otherwise, upon any termination: the rights and licenses
        granted to you in these terms will end, and you must stop using the app and, if needed, delete it
        from your device.
      </p>

      <h2>Payments and Subscriptions</h2>
      <p>
        Certain features or services in Playlist Transfer: Music Shift may be offered as paid services,
        whether through a one-time purchase or an automatically renewing subscription ("Subscription").
      </p>

      <p>
        Subscription prices and billing terms may vary depending on the duration of the selected plan or the
        type of device you use. Subscriptions are prepaid and charged at the beginning of each billing period.
        We may introduce, modify, suspend, or discontinue subscription features at our sole discretion.
      </p>

      <p>
        We may also change subscription pricing from time to time. If you are already subscribed, any new
        pricing will generally take effect from your next billing cycle, unless otherwise required by the
        relevant app marketplace.
      </p>

      <h2>Free Trial</h2>
      <p>
        We may offer a free trial for certain subscriptions. If you start a free trial, you acknowledge that
        unless you cancel before the trial period ends, you may be billed automatically in accordance with the
        applicable subscription terms then in effect.
      </p>

      <h2>Renewal and Cancellation</h2>
      <p>
        Once you purchase a Subscription, it may renew automatically and your selected payment method may be
        charged unless you cancel through your App Store or Google Play account, as applicable. If you cancel,
        you may continue to have access until the end of the current billing period, subject to the platform's
        billing rules.
      </p>

      <h2>Payment Processors</h2>
      <p>
        Payments may be processed through third-party in-app payment providers, including Apple App Store,
        Google Play, or other payment processors made available by the platform. Your purchases are therefore
        also subject to the terms and privacy policies of those providers. We are not responsible for the acts
        or omissions of third-party payment processors.
      </p>

      <h2>Refunds</h2>
      <p>
        Refund eligibility, refund timing, and billing disputes may be subject to the rules of the payment
        platform through which you purchased the service. Where applicable, the Company may issue full or
        partial refunds in accordance with its refund policy and the marketplace rules governing the purchase.
      </p>

      <h2>Apple Refund Request Data</h2>
      <p>
        In accordance with App Store refund procedures, if a user initiates a refund request, Apple may ask us
        to provide limited subscription-consumption information to assist in evaluating that request. By using
        the app, you acknowledge and agree that such limited subscription-related data may be shared with Apple
        where required for refund processing.
      </p>

      <h2>Changes to These Terms</h2>
      <p>
        We may update our Terms and Conditions from time to time. You are therefore advised to review this
        page periodically for any changes. We will notify you of any changes by posting the new Terms and
        Conditions on this page.
      </p>

      <p class="effective-date">These terms and conditions are effective as of 2026-08-15.</p>

      <h2>Contact Us</h2>
      <p>
        If you have any questions or suggestions about these Terms and Conditions, please contact us at
        <a href="mailto:yikenxinxin@gmail.com">yikenxinxin@gmail.com</a>.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsOfService'
}
</script>

<style scoped>
.terms-page {
  background: linear-gradient(180deg, #f8f9fa 0%, #e9ecef 100%);
  color: #1a1a2e;
  min-height: 100vh;
  padding: 6rem 0;
}

.container {
  max-width: 900px;
  margin: 0 auto;
  padding: 3rem;
  background: white;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  position: relative;
}

.back-home {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #3DADFE;
  text-decoration: none;
  font-weight: 600;
  margin-bottom: 2rem;
  transition: color 0.3s;
}

.back-home:hover {
  color: #2b8fd9;
}

h1 {
  font-size: 3rem;
  font-weight: 800;
  margin-bottom: 2rem;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

h2 {
  font-size: 1.8rem;
  font-weight: 700;
  color: #6366f1;
  margin-top: 3rem;
  margin-bottom: 1rem;
}

p {
  line-height: 1.8;
  margin-bottom: 1.5rem;
  color: #4b5563;
}

.intro {
  font-size: 1.1rem;
  color: #6b7280;
}

.effective-date {
  font-weight: 600;
  color: #374151;
}

ul {
  margin-left: 2rem;
  margin-bottom: 1.5rem;
}

li {
  line-height: 1.8;
  color: #4b5563;
  margin-bottom: 0.5rem;
}

a {
  color: #6366f1;
  text-decoration: none;
  transition: color 0.3s;
}

a:hover {
  color: #8b5cf6;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .terms-page {
    padding: 4rem 1rem;
  }

  .container {
    padding: 2rem 1.5rem;
  }

  h1 {
    font-size: 2rem;
  }

  h2 {
    font-size: 1.5rem;
  }
}
</style>
